export default "__VITE_ASSET__CcwKcqOQ__";